import type { CSSProperties, FC, PropsWithChildren } from 'react'
import ReactDOM from 'react-dom'

import { useDelayedState } from '../hooks/useDelayedState'

const modalRoot = document.getElementById('modal-root') || document.createElement('div')

const useAnimationStyles = (isOpen: boolean, duration: number) => {
  const initialStyles: CSSProperties = {
    inset: 0,
    opacity: 0,
    position: 'fixed',
    zIndex: -1,
  }
  const openStyles: CSSProperties = {
    opacity: 1,
    transition: `all ${duration}ms ease-in`,
    zIndex: 1,
  }
  const closedStyles: CSSProperties = {
    opacity: 0,
    transition: `all ${duration}ms ease-out`,
  }

  return {
    ...initialStyles,
    ...(isOpen ? openStyles : closedStyles),
  }
}

type FullScreenContainerProps = FC<
  PropsWithChildren<{
    isOpen: boolean
    className?: string
  }>
>

const Portal: FullScreenContainerProps = ({ className, children, isOpen }) => {
  const { isDelayedState: isDelayedOpen, duration } = useDelayedState(isOpen)
  const styles = useAnimationStyles(isOpen, duration)

  return ReactDOM.createPortal(
    <div className={className} style={styles}>
      {isDelayedOpen ? children : null}
    </div>,
    modalRoot,
  )
}

export const FullScreenContainer: FullScreenContainerProps = ({ children, ...rest }) => (
  <>
    <Portal {...rest}>{children}</Portal>
    {children}
  </>
)
